<template>
  <div class="quote__information-flex">
    <div class="quote__information-members">{{ adults }} {{ adultsLabel }}{{ children ? ',' : '' }} <span v-show="children" class="persons-children">{{ children }} {{ childrenLabel }}</span></div>
    <div class="quote__information-date"> {{ dateStart }} - {{ dateEnd }}</div>
  </div>
</template>

<script>

export default {
  name: 'AdultsDisplay',
  props: [
    'adults',
    'children',
    'dateStart',
    'dateEnd'
  ],
  computed: {
    adultsLabel () {
      return this.adults > 1
        ? this.$t('qic_counter_adults_plural')
        : this.$t('qic_counter_adults_single')
    },
    childrenLabel () {
      if (!this.children) return ''
      return this.children > 1
        ? this.$t('qic_counter_children_plural')
        : this.$t('qic_counter_children_single')
    }
  }
}
</script>

<style scoped>
  .user-data {
    display: flex;
    flex-direction: row;
    align-content: flex-end;
    justify-content: space-between;
    line-height: 24px;
    font-size: 16px;
    font-weight: 400;
  }
</style>
